export const SET_ALL_EMPLOYEES_DATA = 'SET_ALL_EMPLOYEES_DATA'
export const SET_SINGLE_EMPLOYEE_DATA = 'SET_SINGLE_EMPLOYEE_DATA'
export const SET_SINGLE_EMPLOYEE_CHARTS = 'SET_SINGLE_EMPLOYEE_CHARTS'
export const SET_SINGLE_EMPLOYEE_ALL_TRANSACTIONS_DATA = 'SET_SINGLE_EMPLOYEE_ALL_TRANSACTIONS_DATA'
export const SET_SINGLE_EMPLOYEE_TRANSACTIONS_BALANCE_DATA = 'SET_SINGLE_EMPLOYEE_TRANSACTIONS_BALANCE_DATA'
export const SET_SINGLE_EMPLOYEE_RESULTS = 'SET_SINGLE_EMPLOYEE_RESULTS'
export const SET_LOADING = 'SET_LOADING'
